import { UseFormReturn } from 'react-hook-form';
import { addHours, startOfHour } from 'date-fns';

import { EditableSession } from 'types/event.types';

import { sessionToUpdateFormValues } from './schemas';

/**
 * Reset session time fields to their original values (for existing sessions)
 * or to default values (for new sessions)
 */
export const resetSessionTimeFields = (
  form: UseFormReturn<any>,
  session?: EditableSession,
  timezoneCode?: string
): void => {
  if (session && timezoneCode) {
    // For existing sessions, reset to original values
    const originalValues = sessionToUpdateFormValues(session, timezoneCode);

    form.setValue('startDateTime', originalValues.startDateTime, {
      shouldValidate: true,
      shouldDirty: false
    });
    form.setValue('endDateTime', originalValues.endDateTime, {
      shouldValidate: true,
      shouldDirty: false
    });
  } else {
    // For new sessions, reset to default values
    const defaultStartDateTime = addHours(startOfHour(new Date()), 1);
    const defaultEndDateTime = addHours(startOfHour(new Date()), 2);

    form.setValue('startDateTime', defaultStartDateTime, {
      shouldValidate: true,
      shouldDirty: false
    });
    form.setValue('endDateTime', defaultEndDateTime, {
      shouldValidate: true,
      shouldDirty: false
    });
  }
};
